import { Component, OnInit } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { Store } from '@ngrx/store';
import CustomStore from 'devextreme/data/custom_store';
import { OptionChangedEvent } from 'devextreme/ui/accordion';
import { Map } from 'immutable';
import {
	BehaviorSubject,
	firstValueFrom,
	Observable,
	of,
	switchMap,
	takeUntil,
	tap,
	timer,
} from 'rxjs';
import { DcLoaders } from 'src/app/ui/app-loaders';

import { getTraceListPerPage, TraceSelector } from '../../store';
import { TraceItemEntity } from './trace-item.entity';
import { TraceListEntity } from './trace-list.entity';
@Component({
	selector: 'app-trace-list',
	templateUrl: './trace-list.component.html',
	styleUrls: ['./trace-list.component.scss'],
	inputs: ['limit', 'page'],
})
export class TraceListComponent extends DcBaseComponent implements OnInit {
	protected readonly DcLoaders = DcLoaders;
	public dataSource = new CustomStore();
	public vo$!: Observable<{
		isFirstLoad: boolean;
		isLoading: boolean;
		list: TraceListEntity;
		total: number;
	}>;
	public data$!: Observable<{
		list: Map<string, TraceItemEntity>;
		total: number;
	}>;
	public pageIndex = 0;
	public pageSize = 20;

	private readonly firstLoadSubject = new BehaviorSubject<boolean>(true);

	public constructor(
		private readonly store: Store,
		private readonly traceSelector: TraceSelector
	) {
		super();
		this.cmpId = 'trace-list';
		this.triggerInit();
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.store.dispatch(
			getTraceListPerPage({
				offset: this.getOffset(),
				limit: this.pageSize,
			})
		);
	}

	public onPageChange(event: OptionChangedEvent): void {
		if (event.name !== 'paging') {
			return;
		}

		const action: string = event.fullName;
		if (action.includes('pageSize')) {
			this.pageSize = event.value;
			this.pageIndex = 0;
		} else if (action.includes('pageIndex')) {
			this.pageIndex = event.value;
		} else {
			return;
		}
		this.store.dispatch(
			getTraceListPerPage({
				offset: this.getOffset(),
				limit: this.pageSize,
			})
		);
	}

	public async onGridContentReady(): Promise<void> {
		// FIXME: needs to add refresh
		// this.firstLoadSubject.next(true);
		// this.grid?.instance.beginCustomLoading('');
		const firstLaod = await firstValueFrom(this.firstLoadSubject);

		if (firstLaod) {
			this.firstLoadSubject.next(false);
		}
		// if (firstLoad) {
		// 	await firstValueFrom(
		// 		timer(1000).pipe(
		// 			tap(() => {
		// 				this.firstLoadSubject.next(false);
		// 				this.grid?.instance.endCustomLoading();
		// 			})
		// 		)
		// 	);
		// }
	}

	private triggerInit(): void {
		combineAll({
			limit: this.toObservable<number>('limit'),
			page: this.toObservable<number>('page'),
		})
			.pipe(
				takeUntil(this.onDestroy$),
				tap(({ limit, page }) => {
					this.pageIndex = page - 1;
					this.pageSize = limit;
				}),
				switchMap(() =>
					combineAll({
						isFirstLoad: this.firstLoadSubject,
						isLoading: this.traceSelector.getLoading$(),
						list: this.traceSelector.getTraceList$(),
						total: this.traceSelector.getTotal$(),
					}).pipe(
						tap(({ isFirstLoad, isLoading, list, total }) => {
							this.vo$ = of({
								isFirstLoad,
								isLoading,
								list,
								total,
							});
							this.dataSource = new CustomStore({
								load: (): Promise<{
									data: Array<TraceItemEntity>;
									totalCount: number;
								}> =>
									Promise.resolve({
										data: list.elements.toList().toArray(),
										totalCount: total,
									}),
							});
						})
					)
				)
			)
			.subscribe();
	}

	private getOffset(): number {
		return this.pageIndex * this.pageSize;
	}
}
